export const PLACEHOLDER_VALUE = "Dummy";

/**
 * Returns placeholder label for dependent dropdowns.
 * When a parent is selected but no child options exist, shows "No {Entity} available".
 */
export function getDependentPlaceholderLabel(
  isParentSelected,
  optionCount,
  defaultPlaceholder,
  emptyPlaceholder,
) {
  if (isParentSelected && optionCount === 0) {
    return emptyPlaceholder;
  }
  return defaultPlaceholder;
}
